<template>
  <create-comment-pog
    v-if="comment"
    :comment="comment"
    @show-message="showMessage"
    @create-comment="submitComment"
  ></create-comment-pog>
  <v-layout v-else align-center class="text-xs-center">
    <v-flex xs12 sm6 offset-sm3>
      <v-card>
        <v-list two-line>
          <v-layout
            align-center
            v-for="(item, index) in modeledComments"
            :key="index"
          >
            <v-flex sm1>
              <v-btn
                v-if="index > 0"
                icon
                dark
                color="red"
                @click="deleteComment(index)"
                ><v-icon>close</v-icon></v-btn
              >
            </v-flex>
            <v-flex sm11>
              <v-list-tile avatar @click="editComment(index, item)">
                <v-list-tile-avatar v-if="item.text">
                  <v-icon> edit </v-icon>
                </v-list-tile-avatar>
                <v-list-tile-avatar v-else>
                  <v-icon color="primary"> add </v-icon>
                </v-list-tile-avatar>

                <v-list-tile-content>
                  <v-list-tile-title
                    v-html="`<b>${item.date ? item.date : ''}</b>`"
                  ></v-list-tile-title>
                  <v-list-tile-sub-title
                    v-html="item.text"
                    class="text-truncate"
                  ></v-list-tile-sub-title>
                </v-list-tile-content>
              </v-list-tile>
            </v-flex>
          </v-layout>
        </v-list>
        <v-btn color="primary" @click="$emit('close-comments')">done</v-btn>
      </v-card>
    </v-flex>
  </v-layout>
</template>

<script>
import CreateCommentPOG from "@/components/pog/CreateCommentPOG";

export default {
  name: "EditCommentPOG",

  components: {
    "create-comment-pog": CreateCommentPOG,
  },

  props: {
    comments: {
      type: Array,
      default() {
        return [];
      },
    },
  },

  beforeMount() {
    if (this.comments.length === 0) {
      this.modeledComments.push({
        date: "Create your first milestone",
        text: null,
      });
    } else {
      this.modeledComments.push({
        date: "Create another milestone",
        text: null,
      });
      this.comments.forEach((comment) => {
        this.modeledComments.push(comment);
      });
    }
  },

  data() {
    return {
      modeledComments: [],
      comment: null,
      editMode: false,
    };
  },

  methods: {
    showMessage(msg, color) {
      this.$emit("show-message", msg, color);
    },

    editComment(index, comment) {
      if (index !== 0) {
        this.editMode = index;
        this.comment = comment;
      } else {
        this.comment = {
          date: null,
          text: null,
        };
      }
    },

    deleteComment(index) {
      this.$swal.fire({
        title: "Confirm",
        text:
          "Are you sure you want to delete this Milestone? This action may not be reversed.",
        type: "warning",
        showCancelButton: true,
        cancelButtonText: "Oops...keep it",
        confirmButtonText: "Yes, I'm sure",
        allowOutsideClick: false,
        allowEscapeKey: false,
      }).then((response) => {
        if (response.value) {
          let i = -1;
          this.modeledComments = this.modeledComments.filter(() => {
            i++;
            return i !== index;
          });
          this.$emit("delete-comment", index - 1);
        }
      });
    },

    submitComment(comment) {
      if (comment) {
        if (this.editMode) {
          this.modeledComments[this.editMode] = comment;
          this.$emit("create-comment", comment, this.editMode - 1);
        } else {
          this.modeledComments[0] = {
            date: "Create another milestone",
            text: null,
          };
          this.modeledComments.push(comment);
          this.$emit("create-comment", comment, null);
        }
      }
      this.comment = null;
      this.editMode = false;
    },
  },
};
</script>
